import { Component, OnInit } from '@angular/core';
import { NeproseService } from '../services/neprose.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';

@Component({
  selector: 'app-properties',
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.css']
})
export class PropertiesComponent implements OnInit {

  properties = []

  searchForm: FormGroup

  provinceList = []

  districtList = []

  propertyTypes = []

  municipalityList = []

  loading: boolean = true

  page: number = 1

  firstpage: number = 1

  lastpage: number = 1

  selectedOption: string = 'date'

  selectedFilterOption: string = 'new'

  availableFilterOptions = [
    {value: 'new', viewValue: 'New'},
    {value: 'old', viewValue: 'Old'},
  ]

  seoData: SeoSocialShareData = {
    title:  'Neprose - Properties',
    description: 'Find beautiful properties near you with NEPROSE.',
    image: environment.url+'/assets/logo.png'
  };

  constructor( private neproseService: NeproseService, private route: ActivatedRoute, private router: Router, private seo: SeoSocialShareService ) { }

  ngOnInit(): void {
    this.seo.setData(this.seoData)
    this.route.data.subscribe((data: {propertyType: any, provinceList: any, districtList: any, municipalityList: any})=> {
      this.propertyTypes = data.propertyType
      this.provinceList = data.provinceList.provinces
      this.districtList = data.districtList.districts
      this.municipalityList = data.municipalityList.municipalities
    })

    this.getProperties()

    this.searchForm = new FormGroup({
      type: new FormControl(null, [Validators.required]),
      keyword: new FormControl(''),
      listingFor: new FormControl(null, [Validators.required]) 
    })

  }

  changeFilterValues(){
    if(this.selectedOption == 'price'){
      this.availableFilterOptions = [
        {value: 'low', viewValue: 'Low'},
        {value: 'high', viewValue: 'High'},
      ]
      this.selectedFilterOption = 'low'
      this.getProperties()
    }else if(this.selectedOption == 'date'){
      this.availableFilterOptions = [
        {value: 'new', viewValue: 'New'},
        {value: 'old', viewValue: 'Old'},
      ]
      this.selectedFilterOption = 'new'
      this.getProperties()
    }
  }

  getProperties(){
    this.properties = []
    let offset = (this.page - 1)*20
    this.neproseService.getProperties(offset, this.selectedOption, this.selectedFilterOption).subscribe(data => {
      this.loading = false
      if(data.propertiesAd){
        this.lastpage = Math.ceil(data.total/20)
        if(this.page > this.lastpage){
          this.page = 1
        }
        let properties = data.propertiesAd
        for(let property of properties){
          if(property.status == 'completed'){
            property['featuredImage'] = null
            let propertyImages = JSON.parse(property.PropertyImage.imagePath)
            if(propertyImages.length > 0){
              property.featuredImage = environment.api+'/images/'+propertyImages[0]
            }
            let municipality = this.municipalityList.find(municipality => municipality.id == property.municipality_id)
            let address = municipality.municipality
            if(property.village){
              address = property.village+', '+address
            }
            property['address'] = address

            //Nepali Style comma separated number for price
            let lastThree = property.price.toString().substring(property.price.toString().length-3);
            let otherNumbers = property.price.toString().substring(0,property.price.toString().length-3);
            if(otherNumbers != '')
                lastThree = ',' + lastThree;
            property['price'] = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
            //End

            this.properties.push(property)
          }
        }
      }
    }, error => {
      this.loading = false
    })
  }

  search(){
    if(this.searchForm.valid){
      if(this.searchForm.value.keyword){
        this.router.navigate(['/search-result/'+this.searchForm.value.type+'/'+this.searchForm.value.listingFor+'/'+this.searchForm.value.keyword])
      }else{
        this.router.navigate(['/search-result/'+this.searchForm.value.type+'/'+this.searchForm.value.listingFor])
      }
    }
  }

  firstPage(){
    if(this.page != 1){
      this.page = 1
      this.loading = true
      this.getProperties()
    }
  }

  previousPage(){
    if(this.page > 1){
      this.page = this.page - 1
      this.loading = true
      this.getProperties()
    }
  }

  nextPage(){
    if(this.page < this.lastpage){
      this.page = this.page + 1
      this.loading = true
      this.getProperties()
    }
  }

  lastPage(){
    if(this.page != this.lastpage){
      this.page = this.lastpage
      this.loading = true
      this.getProperties()
    } 
  }

}
